module.exports = __webpack_public_path__ + "img/armhole length front.d1aa2bd6.png";